// extracted by mini-css-extract-plugin
export var externalLink = "_ee-0";
export var internalLinkLabel = "_ee-1";